import {
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
} from '@mui/material';
import type { EmailFieldProps } from './IEmailField';

const EmailField = ({
    id,
    name,
    label,
    value,
    error,
    helperText,
    disabled,
    onChange,
    onBlur,
}: EmailFieldProps) => (
    <FormControl variant="outlined" error={error} fullWidth disabled={disabled}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <OutlinedInput
            id={id}
            label={label}
            inputProps={{ onBlur }}
            onChange={onChange}
            value={value}
            name={name}
            type="text"
            aria-describedby={`${id}-helper-text`}
        />
        <FormHelperText id={`${id}-helper-text`}>{helperText}</FormHelperText>
    </FormControl>
);

export default EmailField;
